import _ from 'lodash';
import PropTypes from 'prop-types';
import { ADMIN_ACTIONS, CURRENT_ACTIONS } from '../actions/types';
export const agencyAdminPropTypes = PropTypes.shape({
    id: PropTypes.number,
    admin_id: PropTypes.number,
    agency_id: PropTypes.number,
    is_default: PropTypes.bool,
    agency_name: PropTypes.string
});
export const organizationAdminPropTypes = PropTypes.shape({
    id: PropTypes.number,
    organization_name: PropTypes.string,
    organization_id: PropTypes.number,
    admin_id: PropTypes.number,
    is_default: PropTypes.bool,
    admin_name: PropTypes.string
});
export const currentAdminPropTypes = PropTypes.shape({
    if: PropTypes.number,
    name: PropTypes.string,
    email: PropTypes.string,
    is_client_admin: PropTypes.bool,
    client_id: PropTypes.number,
    is_account_manager: PropTypes.bool,
    show_ids: PropTypes.bool,
    admin_has_users: PropTypes.bool,
    role_ids: PropTypes.arrayOf(PropTypes.number),
    authentication_token: PropTypes.string,
    avatar: PropTypes.shape({
        url: PropTypes.string,
        small: PropTypes.shape({ url: PropTypes.string }),
        medium: PropTypes.shape({ url: PropTypes.string }),
        initial: PropTypes.shape({ url: PropTypes.string })
    }),
    enable_two_factor_auth: PropTypes.bool,
    has_api_access: PropTypes.bool,
    is_active: PropTypes.bool,
    mobile_for_2fa: PropTypes.string,
    timezone: PropTypes.string,
    last_log_attempt_ip: PropTypes.string,
    roles_names: PropTypes.arrayOf(PropTypes.string),
    verification_code: PropTypes.string,
    is_super_admin: PropTypes.bool,
    linked_to_user: PropTypes.bool,
    associated_portal_info: PropTypes.arrayOf(PropTypes.any),
    featurebase_authentication_token: PropTypes.string,
    metabase_authentication_token: PropTypes.string,
    user: PropTypes.any,
    logged_in_as: PropTypes.string,
    admin_permissions: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.string)]),
    client_name: PropTypes.string,
    admin_clients: PropTypes.arrayOf(PropTypes.any),
    agency_admins: PropTypes.arrayOf(agencyAdminPropTypes),
    organization_admins: PropTypes.arrayOf(organizationAdminPropTypes),
    client_account_managers: PropTypes.arrayOf(PropTypes.any)
});
export const adminsPropTypes = PropTypes.shape({
    admins: PropTypes.arrayOf(currentAdminPropTypes),
    current_admin: currentAdminPropTypes,
    updatingPassword: PropTypes.bool
});
/** @type {AdminsState} */
const initialState = {
    admins: [],
    current_admin: { id: null },
    updatingPassword: false
};
/**
 * Reducer to manage the admin state.
 *
 * @param {AdminsState} state
 * @param {{ type: string, payload: any }} action
 *
 * @returns {AdminsState}
 */
export default (state = initialState, { type, payload }) => {
    switch (type) {
        case ADMIN_ACTIONS.SET_CURRENT:
            return { ...state, current_admin: payload };
        case ADMIN_ACTIONS.FETCH:
            return { ...state, ...(payload ? { [payload.id]: payload } : {}) };
        case ADMIN_ACTIONS.CREATE:
        case ADMIN_ACTIONS.EDIT:
            return { ...state, [payload.id]: payload };
        case ADMIN_ACTIONS.DELETE:
            return _.omit(state, payload);
        case ADMIN_ACTIONS.UPDATE_PASSWORD:
            return { ...state, updatingPassword: payload };
        case ADMIN_ACTIONS.FORGOT_PASSWORD:
        case ADMIN_ACTIONS.RESET_PASSWORD:
        case ADMIN_ACTIONS.VERIFY_PASSWORD_TOKEN:
            return { ...state, ...payload };
        case CURRENT_ACTIONS.SET_AGENCY:
            return {
                ...state,
                current_admin: { ...state.current_admin, logged_in_as: 'Agency' }
            };
        case CURRENT_ACTIONS.SET_ORGANIZATION:
            return {
                ...state,
                current_admin: { ...state.current_admin, logged_in_as: 'Organization' }
            };
        default:
            return state;
    }
};
